export const name = 'platform' as const
/**
 * The platform surface's editor-configs conversion spec (ADR-0007) — its own spec rather than the
 * shared `vsmEditorConfigs`, because the `*WixCodeSdk` site configs the platform worker bootstrap
 * consumes must flip together with the platform module that produces the bootstrap.
 */
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const PlatformInitializerSym = Symbol.for('PlatformInitializer')
export { UnfinishedTasksManagerSymbol } from '@wix/thunderbolt-symbols'
export const PlatformWarmupDataManagerSymbol = Symbol('PlatformWarmupDataManager')
export const MainGridAppIdProviderSymbol = Symbol('MainGridAppIdProviderSymbol')
export const PlatformRefreshStateManagerSymbol = Symbol('PlatformRefreshStateManager')
